/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type controlPersonList_viewer = {
    readonly id: string;
    readonly missionControlData: {
        readonly id: string;
        readonly personList: ReadonlyArray<{
            readonly id: string;
            readonly personId: number | null;
            readonly companyId: number | null;
            readonly companyName: string | null;
            readonly accountPlan: string | null;
            readonly firstName: string | null;
            readonly lastName: string | null;
            readonly email: string | null;
            readonly seatType: string | null;
            readonly active: boolean | null;
            readonly profileName: string | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"missionControlHeader_viewer">;
    readonly " $refType": "controlPersonList_viewer";
};
export type controlPersonList_viewer$data = controlPersonList_viewer;
export type controlPersonList_viewer$key = {
    readonly " $data"?: controlPersonList_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"controlPersonList_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchString",
      "type": "String"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "controlPersonList_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MissionControlDataType",
      "kind": "LinkedField",
      "name": "missionControlData",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "searchString",
              "variableName": "searchString"
            }
          ],
          "concreteType": "MissionControlPersonListType",
          "kind": "LinkedField",
          "name": "personList",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "personId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "companyId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "companyName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "accountPlan",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "seatType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "active",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profileName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "missionControlHeader_viewer"
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = 'b7b3920d0948febd3f1d51eaf3a4f52b';
export default node;
